import axiosInstance, { URLS } from "../axios_instance";
import { SendOtpPayload, LoginDoctorPayload } from "./interfaces/auth_https.interface";

const AUTH_URI = URLS.AUTH_URI;

export const sendOtp = (payload: SendOtpPayload) =>
  axiosInstance.post(`${AUTH_URI}/doctor/send-otp`, payload);

export const loginDoctor = (payload: LoginDoctorPayload) =>
  axiosInstance.post(`${AUTH_URI}/doctor/login`, {
    device: "Web Browser",
    sessionType: "doctor",
    ...payload,
  });

export const getDoctorProfile = () =>
  axiosInstance.get(`${AUTH_URI}/doctor/profile`);

export const updateDoctorProfile = (doctorId: string, payload: any) =>
  axiosInstance.patch(`${AUTH_URI}/doctor/${doctorId}/profile`, payload);

export const updateDoctorStatus = (doctorId: string, status: "online" | "offline") =>
  axiosInstance.patch(`${AUTH_URI}/doctor/${doctorId}/status`, { status });

export const getDoctorDocuments = (doctorId: string) =>
  axiosInstance.get(`${AUTH_URI}/doctor/${doctorId}/documents`);

export const uploadDoctorDocument = (doctorId: string, payload: { documentType: string; documentUrl: string }) =>
  axiosInstance.post(`${AUTH_URI}/doctor/${doctorId}/documents`, payload);
